// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import HttpService from 'src/lib/HttpService';

const DEFAULT_CREATE_CUSTOMER_USER_URL =
    'api/ustrl/v1.0/api/users';

export interface Address {
    postalCode?: string;
    countryNumber?: string;
}

export interface CreateCustomerUserRequest {
    firstName: string;
    lastName: string;
    addresses: Address[];
    contactNumbers: [
        {
            number: string;
        }
    ];
    emails: [
        {
            emailId: string;
        }
    ];
    preferenceInfo: {
        preferences: {
            languageId: string;
        }
    };
    category: string;
}

export default {
    async createCustomerUser(request: CreateCustomerUserRequest) {
        const response = await HttpService.proxiedApiCall({
            requestUrl: `${DEFAULT_CREATE_CUSTOMER_USER_URL}`,
            type: 'post',
            body: request,
        });

        return response;
    },
};